import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuthorizationContext } from 'app/module/Authorization';
import utils from 'utils';
import usePlansAPI from 'app/hooks/plans/usePlansAPI';
import useAuthorizationModel from '../../hooks/authorization/useAuthorizationModel';

declare global {
  interface Window {
    Chatbotize: any;
    zE: any;
  }
}

function LogoutContainer() {
  const { actions } = useAuthorizationContext();
  const { isZendeskAuthorization } = useAuthorizationModel();
  const { clearPlanState } = usePlansAPI();
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const returnTo = queryParams.get('return_to');

  useEffect(() => {
    // Clear user credentials.
    utils.clearLocalStorage();
    utils.clearSessionData();
    utils.clearUserSession();

    clearPlanState();

    window?.Chatbotize?.hide();
    window.zE?.('webWidget', 'hide');

    if (isZendeskAuthorization) {
      window.location.replace(returnTo || '/');
    } else {
      actions.logout();
    }
  }, []);

  return null;
}

export default LogoutContainer;
